export default "__VITE_ASSET__BqjJzQN0__"